<script lang="ts">
  import { ConfigStore } from '../../store/config';
  import InputTheme from './input-theme.svelte';
  import { _ } from 'svelte-i18n';

  export let cardTitle = '';
  export let placeholder = '';
  export let cardValue = '';
  export let validateCard: (val: string) => string | null = () => null;
  export let handleValidCard: (detail: any) => void = () => {};
  export let handleInvalidCard: (detail: any) => void = () => {};
</script>

<div class="cs-card">
  <p class="cs-card-title">
    {cardTitle}
  </p>
  <div class="cs-card-input-wrapper">
    <InputTheme
      name="card"
      {placeholder}
      bind:value={cardValue}
      validator={validateCard}
      onValid={handleValidCard}
      onInvalid={handleInvalidCard}
    />
  </div>
</div>

<style lang="scss">
  @use './../../../scss/components/themes/card-theme';
</style>
